import filesize from "filesize";

import { injectIntl } from "react-intl";
import { iconForFileName } from "../../utils/fileUtils";
import { intlShape } from "../../shapes";
import { ActionButton } from "../../index";
import { handleFormikValueChange } from "../../utils/formikUtils";
import { ActionBar } from "../ActionBar";

type Props = {
  uploading?: boolean;
  filesUploadNameReference?: string;
  values?: $TSFixMe;
  handleBlur?: $TSFixMeFunction;
  handleChange?: $TSFixMeFunction;
  intl?: intlShape;
};

export function FilesUploadList(props: Props) {
  const {
    intl,
    handleChange,
    handleBlur,
    values,
    filesUploadNameReference,
    uploading,
  } = props;
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  const attachments = values[filesUploadNameReference]?.acceptedFiles || [];
  const fileIcon = uploading ? "icon-eh-load" : "icon-eh-delete";

  const onDeleteFile = (file: $TSFixMe) => {
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    const newAcceptedFilesList = values[filesUploadNameReference]?.acceptedFiles // prettier-ignore
      .filter((acceptedFile: $TSFixMe) => acceptedFile.path !== file.path); // ? better identification of file?
    handleFormikValueChange(
      { handleChange, handleBlur, name: filesUploadNameReference },
      { acceptedFiles: newAcceptedFilesList },
    );
  };

  const renderFileList = (file: $TSFixMe, index: $TSFixMe) => (
    <div key={index} className="list-item">
      <div className="list-item-icon">
        <span className={` icon ${iconForFileName(file.name)}`} />
      </div>
      <div className="list-item-content">
        <div className="list-item-header-only">{file.name}</div>
      </div>
      <div id="file-size">{filesize(file.size)}</div>
      <div
        className="btn-group"
        style={{ marginBottom: "0px", height: "40px" }}
      >
        <ActionButton
          id="button-delete"
          defaultLabel=""
          icon={fileIcon}
          onClick={() => onDeleteFile(file)}
          disabled={uploading}
        />
      </div>
    </div>
  );

  const fileItems = attachments?.map((file: $TSFixMe, index: $TSFixMe) =>
    renderFileList(file, index),
  );

  return (
    <div id="uploaded-files-list" className="space-after">
      <ActionBar>
        <h3 className="file-list-header">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {intl.formatMessage({ id: "add.attachments.header" })}
        </h3>
      </ActionBar>
      <div className="list">{fileItems}</div>
    </div>
  );
}

export default injectIntl(FilesUploadList);
